import styled from 'styled-components';

const HeaderGroup = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 16px;
`;

const VerticalLine = styled.div`
  background: var(--color-border-default);
  height: 16px;
  width: 1px;
`;

const Appreciations = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
`;

const ContactDetailWrapper = styled.div`
  position: relative;
`;

const ContentBody = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const ContactDetail = styled.div`
  flex: 1.7;

  .item-body {
    padding: 16px 0;
  }
`;

const AppreciationDetail = styled.div``;

const FeatureBox = styled.div``;

const FeatureBody = styled.div`
  align-items: flex-start;
  align-self: stretch;
  background: var(--color-bg-weaker);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-6);
  padding: var(--size-padding-12);
`;

const TagsContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  left: 0;
  overflow: auto;
  overflow: hidden;
  overflow-x: auto;
  padding-right: 16px;
  position: absolute;
  right: 0;
  scrollbar-width: none;
  white-space: nowrap;
`;

const AppreciationItem = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  width: 100%;
`;

export {
  AppreciationDetail,
  AppreciationItem,
  Appreciations,
  ContactDetail,
  ContactDetailWrapper,
  ContentBody,
  FeatureBody,
  FeatureBox,
  HeaderGroup,
  TagsContainer,
  VerticalLine
};
